import { useEffect, useState } from "react";
import AccessGroupService from "../../services/AccessGroupService";
import { useUserStore } from "../../contexts/userStore";
import Select from "../Select/Select";
import { useAuth } from "../../contexts/auth";
import { useTranslation } from "react-i18next";

export function SelectAccessGroup({
   group,
   onChange,
   onlyUnit = true,
   ...props
}) {
   const [groups, setGroups] = useState([]);
   const { user } = useAuth();
   const { selectedCondominio } = useUserStore();
   const { t } = useTranslation();

   async function fetchGroups() {
      try {
         const { data: groups } = onlyUnit ? await AccessGroupService.listCondominiumAccessGroups(selectedCondominio) : await AccessGroupService.listOrganizationAccessGroups(user.userData.selectedOrganization.id);
         if (Array.isArray(groups)) {
            setGroups(groups);
         }
      } catch (err) {
         console.error(err);
      }
   }

   useEffect(() => {
      fetchGroups();
   }, [selectedCondominio]);

   return (
      <Select
         labelText={`${t("common.accessGroup")}${props.required ? '*' : ''}`}
         value={group}
         onChange={({ target }) => {
            onChange?.(target.value)
         }}
         disabled={props.formMode === "consulta"}
         required={props.required}
         options={[
            ...groups?.map(group => ({ value: group.id, text: group.name }))
         ]}
      />
   );
}